import { STEPS_COMMON_DATA } from './steps.common';
import { STEPS_CO_DATA } from './steps.continuousOptimization';
import { STEPS_PD_DATA } from './steps.productDescription';
import { STEPS_EDIT_BRIEF_DATA } from './steps.editBrief';
import { STEPS_WORKSPACES_DATA } from './steps.workspaces';
import { STEPS_DOCUMENT_DATA } from './steps.document';
import { STEPS_ACCOUNTS_DATA } from './steps.accounts';
import { STEPS_WTM_DATA } from './steps.wtm';

export const STEPS_DATA = [
  ...STEPS_COMMON_DATA,
  ...STEPS_CO_DATA,
  ...STEPS_PD_DATA,
  ...STEPS_EDIT_BRIEF_DATA,
  ...STEPS_WORKSPACES_DATA,
  ...STEPS_ACCOUNTS_DATA,
  ...STEPS_DOCUMENT_DATA,
  ...STEPS_WTM_DATA,
];
